import {getBeijing} from "@/http/axios/request";

/**
 * 动态下拉列表接口
 * @url 接口路径
 * @label 显示值
 * @value 绑定值
 * @queryKey 查询数据参数key值，如没有queryKey，则使用label用做参数key值
 * @method 接口请求方式 默认get
 */
const apiList = {
  // 用户下拉
  findByKeyWords: {
    url: 'user/info/findByKeyWords',
    label: 'mobile',
    value: 'mobile',
    queryKey: 'keyWords'
  },
  // 活动下拉
  activityList: {
    url: 'vehicle/activity/list/search',
    label: 'name',
    value: 'id',
    method: 'post',
    pageIndexKey: 'pageNum'
  },
  recommendActivityList: {
    url: '/beijing-zone-opt/recommendActivity/list',
    label: 'name',
    value: 'id',
    method: getBeijing,
    transformResult: false,
    pageIndexKey: 'pageIndex'
  },
  // 车型列表
  modelList: {
    url: '/beijing-info-vehicle/vehicleModelInterior/option',
    label: 'modelName',
    value: 'modelId',
    method: getBeijing,
  }
};

export const getApiConfig = (type) => {
  return apiList[type] || {};
};
